import React, { Component } from 'react'

import { List } from 'antd'

import ColumnTitle from '../ColumnTitle'

import bdtit from '../../assets/img/bdtit.png'

import { AnnualReportsWrapper } from './style'

export default class AnnualReports extends Component {
    state = {
        list: [
            {
                id: 're_001',
                title: '“稳”字当头，2021新华网思客年会聚焦中国经济下一程',
                sub: `年会以“中国经济下一程：新格局 新优势 新篇章”为主题，与会嘉宾通过线上形式参会，聚焦后疫情时代全球与中国经济发展，并从国际国内两个市场角度把脉中国经济，寻找经济发展新机遇。`,
                href: 'http://www.xinhuanet.com/sikepro/20211230/2de94355a8aa4018ae3f477a567e4608/c.html'
            },
            {
                id: 're_002',
                title: '高培勇：中国经济新发展阶段“新”在何处？',
                sub: `在新发展阶段做好经济工作必须要统筹好发展与安全，我国宏观政策的配置将越来越和微观基础紧密对接，越来越和市场主体深度融合。`,
                href: 'http://www.xinhuanet.com/sikepro/20211230/3ef3fd029762410f943ca56993f6ae86/c.html'
            },
            {
                id: 're_003',
                title: '朱云来：“双碳”大考下的产业机遇与挑战',
                sub: `光伏能源作为可再生能源，无论是从光伏资源潜力，还是从技术成本、建设成本来看，都具备替代煤炭能源的可行性，从而推动电力系统转型。`,
                href: 'http://www.xinhuanet.com/sikepro/20211229/704e591a3ee94d4a96651389d0703b37/c.html'
            },
            {
                id: 're_004',
                title: '曾光：我们和新冠的斗争是“两军对垒勇者胜”',
                sub: `我们和新冠的斗争是“两军对垒勇者胜”，斗争的目的是为了战胜它，也就是达到一种人类占优势下的平衡。`,
                href: 'http://www.xinhuanet.com/sikepro/20220103/799897a0a7cd4cc299b4ee495da41c72/c.html'
            },
            {
                id: 're_005',
                title: '徐常亮：拓展时空的元宇宙',
                sub: `随着元宇宙的出现，人们的创造力和想象力会起更大的作用。作为共建想象力的最佳载体，元宇宙也会成为我们共同建设想象力的最佳助力。`,
                href: 'http://www.xinhuanet.com/sikepro/20220104/a3e6ef47ecd342f4ae617e97dedd3501/c.html'
            },
            {
                id: 're_006',
                title: '吕廷杰：从信息经济到数字经济的转型',
                sub: `未来十年是社会数字化转型的十年，所有的行业都值得重新做一遍，趋势大于优势，拥抱科技才是正路。`,
                href: 'http://www.xinhuanet.com/sikepro/20211231/058a792fa67149ba9421ec0777b3e88d/c.html'
            },
            {
                id: 're_007',
                title: '张克镇：治未病——循源医学体系与疾病的防治',
                sub: `一个好的医疗体系应该使得健康人群的数量和生命的质量越来越高，而医疗成本和医疗风险越来越低。在临床上应该用一种循源的方式分析病因，追溯到疾病源头，否则，治未病就是一句空话。`,
                href: 'http://www.xinhuanet.com/sikepro/20211231/b4f5ed1e354248efbbfe343be9258680/c.html'
            },
            {
                id: 're_008',
                title: '陈少峰：关于IP元宇宙的思考',
                sub: `元宇宙是通过数字技术、交互技术、人工智能等多种技术结合而呈现的一种沉浸式体验场景，这种场景需要内容支撑才有价值。`,
                href: 'http://www.xinhuanet.com/sikepro/20211231/f3aebb0199494f45925b9aed5296baaf/c.html'
            },
            {
                id: 're_009',
                title: '唐华：数字赋能：新城市、新制造、新农业——成都新津数字化转型的实践探索',
                sub: `新经济企业的成长特别需要政府的支持，需要政府具有投资人的眼光、合伙人的精神，需要陪伴新经济团队共同成长。`,
                href: 'http://www.xinhuanet.com/sikepro/20211230/4bdcf6bb25d14dcd893c862b3bb5fb5a/c.html'
            }
        ]
    }
    render() {
        const { list } = this.state
        // const loadMore = <Button type="text">更多...</Button>
        return (
            <AnnualReportsWrapper>
                <ColumnTitle imgSrc={bdtit} />
                <List
                    className="demo-loadmore-list"
                    itemLayout="horizontal"
                    // loadMore={loadMore}
                    dataSource={list}
                    grid={{ gutter: 16, column: 2 }}
                    renderItem={item => (
                        <List.Item>
                            <List.Item.Meta
                                title={<a href={item.href} rel="noreferrer" target="_blank">{item.title}</a>}
                                description={item.sub}
                            />
                        </List.Item>
                    )}
                />
            </AnnualReportsWrapper>
        )
    }
}
